import { createSelector } from '@ngrx/store';
import { getRepeatOrderState } from '../reducers';

export const getRepeatOrderDetail = createSelector(getRepeatOrderState, state => {
  return state.orderDetail;
});

export const getRepeatOrderDetailLoading = createSelector(getRepeatOrderState, state => {
  return state.loading;
});

export const getRepeatOrderDetailError = createSelector(getRepeatOrderState, state => {
  return state.error;
});

export const getRepeatOrderDetailValidation = createSelector(getRepeatOrderState, state => {
  return state.validation;
});

export const getRepeatOrderNewOrderId = createSelector(getRepeatOrderState, state => {
  return state.newOrderId;
});

export const getRepeatOrderExperience = createSelector(getRepeatOrderState, state => {
  return state.experience;
});

export const getOrderAndValidation = createSelector(getRepeatOrderState, state => {
  return { order: state.orderDetail, validation: state.validation };
});
